import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=39e82bca&scoped=true"
import script from "./FormQuestion.vue?vue&type=script&lang=js"
export * from "./FormQuestion.vue?vue&type=script&lang=js"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=39e82bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e82bca",
  null
  
)

export default component.exports